import { URLS } from '../../constants/urls';

/**
 * Damage claim objects in S3 live on the nest-backend bucket (same root as TRIP_PHOTOS / thumbnails).
 * Values may be a full HTTPS URL or a key like `damage-claims/temp-…/before/….jpg`.
 */
const DAMAGE_CLAIM_PUBLIC_BASE = URLS.S3_BUCKET.CAR_THUMBNAILS;

/** Some older rows saved full URLs on the autopilotee-cars bucket; objects actually live on nest-backend (same key). */
const LEGACY_DAMAGE_CLAIM_S3_HOST = /^autopilotee-cars\.s3\.[a-z0-9-]+\.amazonaws\.com$/i;

function publicBase(): string {
  return (process.env.REACT_APP_S3_PUBLIC_MEDIA_BASE || DAMAGE_CLAIM_PUBLIC_BASE).replace(
    /\/$/,
    '',
  );
}

/**
 * Rewrites mistaken `autopilotee-cars.s3…/damage-claims/…` URLs to the nest-backend bucket.
 */
function rewriteLegacyDamageClaimFullUrl(trimmed: string): string | null {
  if (!/^https?:\/\//i.test(trimmed)) return null;
  try {
    const u = new URL(trimmed);
    if (!LEGACY_DAMAGE_CLAIM_S3_HOST.test(u.hostname)) return null;
    const path = u.pathname.replace(/^\/+/, '');
    if (!path.startsWith('damage-claims/')) return null;
    return `${publicBase()}/${path}${u.search}`;
  } catch {
    return null;
  }
}

export function toPublicS3ObjectUrl(pathOrUrl: string | null | undefined): string {
  if (pathOrUrl == null || pathOrUrl === '') return '';
  const trimmed = String(pathOrUrl).trim();
  const rewritten = rewriteLegacyDamageClaimFullUrl(trimmed);
  if (rewritten) return rewritten;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  const key = trimmed.replace(/^\/+/, '');
  return `${publicBase()}/${key}`;
}

/** Booking trip images: key relative to TRIP_PHOTOS base or full URL (same as TripPhotosModal). */
export function resolveTripPhotoUrl(url: string | null | undefined): string {
  if (url == null || url === '') return '';
  const t = String(url).trim();
  if (/^https?:\/\//i.test(t)) return t;
  return `${URLS.S3_BUCKET.TRIP_PHOTOS}/${t.replace(/^\//, '')}`;
}
